import React from 'react';
import { Bookmark, X, MessageSquare, Clock } from 'lucide-react';

const formatTime = (ts) => {
  if (!ts) return '';
  const d = new Date(ts);
  const now = new Date();
  const diff = now - d;
  if (diff < 86400000) return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  if (diff < 172800000) return 'Yesterday';
  return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
};

const ChatBookmarksPanel = ({ bookmarks, onClose, onNavigate, onRemove }) => {
  return (
    <div className="w-80 flex flex-col bg-slate-900/95 border-l border-slate-800 animate-[slideInRight_0.2s_ease-out]" data-testid="bookmarks-panel">
      <div className="p-4 border-b border-slate-800 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Bookmark className="w-4 h-4 text-amber-400" />
          <h3 className="text-white font-semibold text-sm">Saved Messages</h3>
          <span className="text-slate-500 text-xs">({bookmarks.length})</span>
        </div>
        <button onClick={onClose} className="text-slate-400 hover:text-white p-1 rounded-lg hover:bg-slate-800 transition-colors">
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto">
        {bookmarks.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-center px-6 py-12">
            <Bookmark className="w-10 h-10 text-slate-700 mb-3" />
            <p className="text-slate-500 text-sm">No saved messages yet</p>
            <p className="text-slate-600 text-xs mt-1">Star messages to find them later</p>
          </div>
        ) : (
          <div className="p-2 space-y-1">
            {bookmarks.map((bm, i) => (
              <button key={i} onClick={() => onNavigate(bm.chat_id)}
                className="w-full p-3 rounded-xl hover:bg-slate-800/60 text-left transition-all group" data-testid={`bookmark-${i}`}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs font-medium text-indigo-400">{bm.message_sender}</span>
                  <div className="flex items-center gap-1">
                    <span className="text-[10px] text-slate-600">{formatTime(bm.message_timestamp)}</span>
                    <button onClick={(e) => { e.stopPropagation(); onRemove(bm.message_id); }}
                      className="opacity-0 group-hover:opacity-100 text-slate-500 hover:text-red-400 p-0.5 rounded transition-all">
                      <X className="w-3 h-3" />
                    </button>
                  </div>
                </div>
                <p className="text-xs text-slate-400 line-clamp-2">{bm.message_content}</p>
                <div className="flex items-center gap-1 mt-1">
                  <MessageSquare className="w-3 h-3 text-slate-600" />
                  <span className="text-[10px] text-slate-600">#{bm.chat_id}</span>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
      <style>{`
        @keyframes slideInRight { from { transform: translateX(20px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
      `}</style>
    </div>
  );
};

export default ChatBookmarksPanel;
